import useSWR from 'swr';
import { isAxiosError } from 'axios';
import { getSaVoucherDraftSourceUrl } from '@/constant/approval';
import type { SaVoucherDraftSource } from '@/types/approval';
import { getNestedDataFetcher } from '@/utils/apis';

/**
 * draft-source 실패 사유.
 * - not-found: 404 — SAP 에 없는 묶음번호
 * - sap-unavailable: 408·424 등 — SAP 조회 장애(재시도 대상)
 */
export type SaVoucherDraftSourceErrorKind = 'not-found' | 'sap-unavailable';

const getErrorKind = (
  error: unknown,
): SaVoucherDraftSourceErrorKind | undefined => {
  if (!error) return undefined;
  const status = isAxiosError(error) ? error.response?.status : undefined;
  return status === 404 || status === 422 ? 'not-found' : 'sap-unavailable';
};

/**
 * SA 전표(99) 작성 사전 데이터 — SAP 묶음번호로 전표 합계·라인 조회. 묶음번호 없으면 호출 skip.
 * SAP 원천 조회라 포커스 재검증은 끔
 */
const useSaVoucherDraftSource = (sapDocumentNo?: string | null) => {
  const { data, error, isLoading, mutate } = useSWR<SaVoucherDraftSource>(
    sapDocumentNo ? getSaVoucherDraftSourceUrl(sapDocumentNo) : null,
    getNestedDataFetcher,
    {
      revalidateOnFocus: false,
      shouldRetryOnError: (err) => getErrorKind(err) !== 'not-found',
    },
  );

  return {
    data,
    error,
    errorKind: getErrorKind(error),
    isLoading,
    mutate,
  };
};

export default useSaVoucherDraftSource;
